import { defineStore } from "pinia";
import { useToastStore } from './toast_store.js';
import axios from 'axios';

export const useCombatEncounterStore = defineStore("CombatEncounterStore", {
  state: () => {
    return {
      undetailedMonsters: [],
      detailedMonstersByIndex: {},
      combatants: [],
      diceRolls: [],
      inspectedCombatant: null,
    };
  },

  getters: {
    
  },

  actions: {
    fetchUndetailedMonsters() {
      return new Promise((resolve) => {
        axios.get('https://www.dnd5eapi.co/api/monsters')
          .then(({ data }) => {
            this.undetailedMonsters = data.results;
            resolve(true);
          })
          .catch(() => {
            useToastStore().setErrorToast({ text: 'Could not load monsters. Try again.' });
          })
      });
    },

    fetchDetailedMonster(undetailedMonster) {
      return new Promise((resolve) => {
        let monster = this.detailedMonstersByIndex[undetailedMonster.index];
        if (monster) {
          this.addMonsterToCombatants(monster);
          resolve(true);
        } else {
          axios.get(`https://www.dnd5eapi.co${undetailedMonster.url}`)
            .then(({ data }) => {
              this.detailedMonstersByIndex[undetailedMonster.index] = data;
              this.addMonsterToCombatants(data);
              resolve(true);
            })
            .catch(() => {
              useToastStore().setErrorToast({ text: `Could not find monster with index: ${undetailedMonster.index}` });
            });
        }
      })
    },

    addMonsterToCombatants(monster) {
      this.combatants.push({ ...monster, uuid: crypto.randomUUID() });
    },

    addPlayerToCombatants(name) {
      this.combatants.push({name, uuid: crypto.randomUUID(), isPC: true });
    },

    updateCombatant({ uuid, key, value }) {
      const combatant = this.combatants.find(c => c.uuid === uuid);
      combatant[key] = value;
    },

    destroyCombatant({ uuid }) {
      const idx = this.combatants.findIndex(c => c.uuid === uuid);
      this.combatants.splice(idx, 1);
    },

    sortCombatants() {
      this.combatants = this.combatants.sort((a, b) => {
        const initiativeComp = (b.initiative || 0) - (a.initiative || 0);
        return initiativeComp;
      });
    },

    inspectCombatant(combatant) {
      this.inspectedCombatant = combatant;
    },

    rollDice({ dice, title }) {
      return new Promise((resolve) => {
        const values = [];
        let result = 0;
        const separator = dice.includes(' + ') ? ' + ' : '+';
        dice.split(separator).forEach((value) => {
          if (value.includes('d')) {
            const dieCount = parseInt(value.split('d')[0]);
            const dieType = parseInt(value.split('d')[1]);
            for (let i = 0; i < dieCount; i += 1) {
              const dieValue = Math.ceil(Math.random() * dieType);
              values.push(dieValue);
              result += dieValue;
            }
          } else {
            values.push(parseInt(value));
            result += parseInt(value);
          }
        });
        this.diceRolls.push({ id: Date.now(), result, title, dice, values });
        resolve(result);
      })
    },
  },
});